export default __webpack_public_path__ + "static/media/Japanese.a03704b4.mp3";